import { Component, OnInit, Inject, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GfTitleService } from '../../../core/services/core.title.service';
import { TrackerService } from '../services/tracker.service';
import { ProjectModel } from '../../../core/services/project.model.service';
import { StateService } from '@uirouter/angular';
import { TrackerDeleteComponent } from './trackerDeleteModal/tracker.delete.modal.component';
import * as _ from 'lodash';

@Component({
  selector: 'tracker-admin',
  template: require('./tracker.admin.component.html')
})
export class TrackerAdminComponent implements OnInit {
  @Input() project;
  @Input() tracker;
  @Input() siteConfig;
  @Input() projectMenu: any;

  activeTab: string = 'tab-main-settings';
  trackerUnchanged: any;
  roles: any[] = [];
  selectFields: any[] = [];
  extraFields: any[] = [];
  hostName: string;
  validationErrors: any = {};
  selectedRoles: Array<any> = [];
  rolesLabel: string | false = false;

  constructor(
    private titleService: GfTitleService,
    private stateService: StateService,
    private trackerService: TrackerService,
    private modalService: NgbModal,
    private projectModel: ProjectModel
  ) {}

  ngOnInit() {
    let tabParam = this.stateService.params?.tab;
    if (tabParam) {
      this.activeTab = tabParam;
    }

    this.project = this.projectModel.getCurrentProject();
    this.hostName = _.get(this.siteConfig, 'hostName', '');
    
    if (_.isEmpty(this.tracker)) {
      this.stateService.go('home.project.summary');
      return;
    }

    this.trackerUnchanged = _.cloneDeep(this.tracker);
    if (this.project.isPublic !== 'Y') {
      this.tracker.isPublic = false;
    }

    this.titleService.setTitle(this.tracker.trackerName, 'Admin');
    
    this.projectModel.loadProjectRoles(this.stateService.params.unixName)
      .then((data: any) => {
        this.roles = _.union([{ id: 0, roleName: "None" }], data);
      });

    this.getSelectTypeFields();
    this._getExtraFields();
  }

  private _getExtraFields() {
    this.extraFields = [];
    _.forOwn(this.tracker.fields, (field, alias) => {
      if (field.isExtraField) {
        this.extraFields.push({
          alias: alias,
          fieldName: field.fieldName,
          fieldElements: field.fieldElements
        });
      }
    });

    this.extraFields = [{ alias: "", fieldName: "None" }].concat(this.extraFields);
  }

  getSelectTypeFields() {
    const selectFieldTypes = [1, 2, 3, 5, 7];
    this.selectFields = [];

    _.forOwn(this.tracker.fields, (field, alias) => {
      if (selectFieldTypes.includes(field.fieldType) && field.isEnabled && field.isExtraField) {
        this.selectFields.push({
          id: field.id,
          alias: alias,
          fieldName: field.fieldName,
          fieldElements: field.fieldElements
        });
      }
    });

    this.selectFields = [{ alias: "", fieldName: "None" }].concat(this.selectFields);
  }

  showDeleteTracker() {
    const modalRef = this.modalService.open(TrackerDeleteComponent);
        modalRef.componentInstance.tracker = this.trackerUnchanged;
        modalRef.componentInstance.close.subscribe(() => {
        modalRef.close();
    });
  }

  deleteTracker() {
    _.remove(this.project.rel.trackers, { tracker_id: this.trackerUnchanged.id });
    this.stateService.go('home.project.summary.admin.tracker');
  }

  setActiveTab(strTab: string) {
    if (this.activeTab === strTab) return;

    let params = _.clone(this.stateService.params);
    params.tab = strTab;

    this.stateService.go('.', params, {reload: false, inherit: true, notify: false})
      .then(() => {
        this.activeTab = strTab;
      }, (err: any) => {
        console.log(err);
      });
  }

  cancelChanges() {
    this.tracker = _.cloneDeep(this.trackerUnchanged);
  }

  saveTracker() {
    this.trackerService.save(this.tracker)
      .then(
        () => {
          this.validationErrors = {};
        },
        response => {
          this.validationErrors = _.get(response, 'data', this.validationErrors);
        }
      );
  }

  hasValidationFailure(fieldName: string, validationType?: string) {
    const field = _.get(this.validationErrors, fieldName, false);
    if (field) {
      if (validationType) {
        if (Array.isArray(field)) {
          return !!_.find(field, { 'type': validationType });
        } else {
          return _.has(field, 'type');
        }
      }
      return (Array.isArray(field) && _.size(field) > 0) || _.has(field, 'type');
    }
    return false;
  }

  isRoleReassigned(role: any) {
    if (_.isEmpty(role)) {
      return false;
    }

    return !!_.find(this.tracker.rel.commit_actions.tracker_commit_reassign, roleToReassign =>
      roleToReassign.role.id === role.id);
  }
  private hasRole(role: any): boolean {
    return this.selectedRoles.find((r) => r.id === role.id) !== undefined;
  }
  private toggleRole(role: any): void {
    if (this.hasRole(role)) {
      this.selectedRoles = this.selectedRoles.filter((item) => item !== role);
    } else {
      this.selectedRoles = this.selectedRoles.concat(role);
    }
    this.rolesLabel = this.getRolesLabel();
  }

  private getRolesLabel(): string | false {
    const len = _.get(this.selectedRoles, 'length', 0);
    if (len === 0) {
      return false;
    }
    if (len < 4) {
      return this.selectedRoles.map((item) => item.roleName).join(',');
    }
    return `${this.selectedRoles.length} roles`;
  }

  onNotificationUpdate(param: any) {
    if (param.notification === 'submit') {
      this.tracker.submitInstructions = param.value;
    } else if (param.notification === 'browse') {
      this.tracker.browseInstructions = param.value;
    }
  }
}
